import { axiosInstance } from '@/lib/axios';

// The analysis itself takes longer than the 60s edge timeout, so a request can fail while the
// work carries on and lands on the record. Rather than telling someone their analysis failed when
// it did not, wait for the audit to show its finished analysis.
export const waitForAuditAnalysis = async (auditId, { attempts = 18, intervalMs = 10000 } = {}) => {
  for (let i = 0; i < attempts; i += 1) {
    await new Promise((resolve) => setTimeout(resolve, intervalMs));
    try {
      const { data } = await axiosInstance.get(`/safety-audits/${auditId}`);
      const summary = (data?.aiHazardSummary || '').trim();
      if (summary && summary.toLowerCase() !== 'ai analysis not available') {
        return data;
      }
    } catch (e) {
      // keep waiting — a transient read failure says nothing about the analysis
    }
  }
  return null;
};
